enum CATEGORY_NUMBER {
  CATEGORY_1 = 1,
  CATEGORY_2 = 2,
  CATEGORY_3 = 3,
  CATEGORY_4 = 4,
}

const CATEGORY_RULES = {
  [CATEGORY_NUMBER.CATEGORY_1]: {
    requiresFrontFaceImage: false,
    requiresGovernmentVerification: false,
    requiresIdentificationImage: true,
    requiresProofOfLife: false,
  },
  [CATEGORY_NUMBER.CATEGORY_2]: {
    requiresFrontFaceImage: false,
    requiresGovernmentVerification: true,
    requiresIdentificationImage: true,
    requiresProofOfLife: false,
  },
  [CATEGORY_NUMBER.CATEGORY_3]: {
    requiresFrontFaceImage: true,
    requiresGovernmentVerification: true,
    requiresIdentificationImage: true,
    requiresProofOfLife: false,
  },
  [CATEGORY_NUMBER.CATEGORY_4]: {
    requiresFrontFaceImage: false,
    requiresGovernmentVerification: true,
    requiresIdentificationImage: true,
    requiresProofOfLife: true,
  },
};

export const DEFAULT_ANTI_FRAUD_CATEGORY = CATEGORY_NUMBER.CATEGORY_1;

export default class AntiFraudCategoryRule {
  categoryNumber: CATEGORY_NUMBER;

  constructor(categoryNumber: CATEGORY_NUMBER) {
    this.categoryNumber = categoryNumber;
  }

  get isIdentificationImageRequired(): boolean {
    return CATEGORY_RULES[this.categoryNumber].requiresIdentificationImage;
  }

  get isFrontFaceImageRequired(): boolean {
    return CATEGORY_RULES[this.categoryNumber].requiresFrontFaceImage;
  }

  get isProofOfLifeRequired(): boolean {
    return CATEGORY_RULES[this.categoryNumber].requiresProofOfLife;
  }

  get isGovernmentVerificationRequired(): boolean {
    return CATEGORY_RULES[this.categoryNumber].requiresGovernmentVerification;
  }
}
